import axios from "axios"

export default {
    async CreateOrUpdate(update,data){
        const response = await axios.post(update ? '/api/srcoperations/update' : '/api/srcoperations/create',data)
        return response
    },
    async Table(data){
        const response = await axios.post('/api/srcoperations/table',data)
        return response
    },
    async Delete(id){
        const response = await axios.post(`/api/srcoperations/delete/${id}`)
        return response
    },
    async List(){
        const response = await axios.post('/api/srcoperations/list')
        return response
    },
    Employee:{
        async Create(data){
            const response = await axios.post('/api/srcoperations/employee/create',data)
            return response
        },
        async Update(data){
            const response = await axios.post('/api/srcoperations/employee/update',data)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/srcoperations/employee/table',data)
            return response
        },
        async Report(data){
            const response = await axios.post('/api/srcoperations/employee/report',data)
            return response
        },
        async Dashboard(){
            const response = await axios.get('/api/srcoperations/employee/dashboard')
            return response
        },
        async Delete(id){
            const response = await axios.post(`/api/srcoperations/employee/delete/${id}`)
            return response
        },
    }
}